var _polygon, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 33.122,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.527,
    y: 401.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 8.693,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.586,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.192,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 43.193,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.556,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 6.333,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.471,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 93.676,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8H260.212c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 254.389,
    y: 120.712,
    style: {
      fill: "#EBEBEB"
    },
    width: 169.516,
    height: 189.916
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.389,
    y: 123.775,
    style: {
      fill: "#FAFAFA"
    },
    width: 166.189,
    height: 183.489
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "414.438,221.167 414.438,208.275 410.754,208.275 410.754,199.681 405.843,199.681  405.843,186.789 404.616,186.789 404.616,199.681 399.704,199.681 399.704,208.275 396.021,208.275 396.021,221.167  389.268,221.167 389.268,224.851 386.198,224.851 386.198,238.971 385.584,238.971 385.584,218.712 383.742,218.712  383.742,231.604 381.901,231.604 381.901,200.908 380.673,200.908 380.673,213.801 375.762,213.801 375.762,209.503  373.92,209.503 373.92,191.7 370.237,191.7 370.237,173.897 369.009,173.897 369.009,176.352 343.839,176.352 343.839,168.985  339.541,168.985 339.541,140.746 337.7,140.746 337.7,168.985 331.56,168.985 331.56,176.352 329.105,176.352 329.105,213.187  316.213,213.187 316.213,202.136 320.51,202.136 320.51,200.295 316.213,200.295 316.213,197.225 303.935,197.225  303.935,168.985 300.865,168.985 300.865,164.688 286.131,164.688 286.131,168.985 284.289,168.985 284.289,208.275  277.537,208.275 277.537,226.079 273.853,226.079 273.853,211.959 270.784,211.959 270.784,208.275 264.031,208.275  264.031,195.383 260.347,195.383 260.347,186.789 256.05,186.789 256.05,173.897 254.389,173.897 254.389,307.264  420.577,307.264 420.577,221.167  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 353.239,
    y: 178.277,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.239,
    y: 181.193,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.239,
    y: 192.857,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.239,
    y: 195.773,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.239,
    y: 198.689,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.239,
    y: 207.438,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.239,
    y: 210.354,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.476,
    y: 189.941,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.476,
    y: 192.857,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.476,
    y: 195.773,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.476,
    y: 198.689,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.476,
    y: 201.605,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.476,
    y: 207.438,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.476,
    y: 210.354,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.713,
    y: 178.277,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.713,
    y: 181.193,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.713,
    y: 184.109,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.713,
    y: 187.025,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.713,
    y: 189.941,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.713,
    y: 192.857,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.713,
    y: 195.773,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.713,
    y: 198.689,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.713,
    y: 201.605,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.713,
    y: 204.522,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.713,
    y: 210.354,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.951,
    y: 178.277,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.951,
    y: 181.193,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.951,
    y: 184.109,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.951,
    y: 187.025,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.951,
    y: 189.941,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.951,
    y: 192.857,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.951,
    y: 195.773,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.951,
    y: 222.018,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.188,
    y: 178.277,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.188,
    y: 181.193,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.188,
    y: 184.109,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.188,
    y: 187.025,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.188,
    y: 189.941,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.188,
    y: 192.857,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.188,
    y: 195.773,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.188,
    y: 198.689,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.188,
    y: 216.186,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.188,
    y: 219.102,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.188,
    y: 222.018,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.188,
    y: 224.934,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.188,
    y: 236.598,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.426,
    y: 178.277,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.426,
    y: 181.193,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.426,
    y: 184.109,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.426,
    y: 187.025,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.426,
    y: 189.941,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.426,
    y: 192.857,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.426,
    y: 195.773,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.426,
    y: 198.689,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.426,
    y: 201.605,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.426,
    y: 204.522,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.426,
    y: 213.27,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.426,
    y: 216.186,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.426,
    y: 219.102,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.426,
    y: 222.018,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.426,
    y: 224.934,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.426,
    y: 236.598,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.663,
    y: 178.277,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.663,
    y: 181.193,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.663,
    y: 184.109,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.663,
    y: 187.025,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.663,
    y: 189.941,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.663,
    y: 192.857,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.663,
    y: 195.773,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.663,
    y: 198.689,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.663,
    y: 201.605,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.663,
    y: 204.522,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.663,
    y: 207.438,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.663,
    y: 210.354,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.663,
    y: 213.27,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.663,
    y: 216.186,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.663,
    y: 219.102,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.663,
    y: 222.018,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.663,
    y: 224.934,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.663,
    y: 227.85,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.901,
    y: 178.277,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.901,
    y: 181.193,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.901,
    y: 184.109,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.901,
    y: 187.025,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.901,
    y: 189.941,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.901,
    y: 192.857,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.901,
    y: 195.773,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.901,
    y: 198.689,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.901,
    y: 201.605,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.901,
    y: 204.522,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.901,
    y: 213.27,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.901,
    y: 216.186,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.901,
    y: 219.102,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.901,
    y: 222.018,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.138,
    y: 178.277,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.138,
    y: 181.193,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.138,
    y: 184.109,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.138,
    y: 187.025,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.138,
    y: 189.941,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.138,
    y: 192.857,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.138,
    y: 195.773,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.138,
    y: 198.689,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.138,
    y: 201.605,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.138,
    y: 204.522,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.138,
    y: 213.27,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.138,
    y: 216.186,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.138,
    y: 219.102,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.033,
    y: 170.706,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.033,
    y: 173.622,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.033,
    y: 176.538,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.033,
    y: 179.454,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.033,
    y: 182.37,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.033,
    y: 185.286,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.033,
    y: 188.202,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.033,
    y: 191.118,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.033,
    y: 199.866,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.033,
    y: 202.782,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.271,
    y: 170.706,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.271,
    y: 173.622,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.271,
    y: 176.538,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.271,
    y: 179.454,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.271,
    y: 182.37,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.271,
    y: 185.286,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.271,
    y: 188.202,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.271,
    y: 191.118,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.271,
    y: 202.782,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.508,
    y: 170.706,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.508,
    y: 173.622,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.508,
    y: 176.538,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.508,
    y: 179.454,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.508,
    y: 182.37,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.508,
    y: 185.286,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.508,
    y: 188.202,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.508,
    y: 191.118,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.746,
    y: 170.706,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.746,
    y: 173.622,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.746,
    y: 176.538,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.746,
    y: 179.454,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.746,
    y: 182.37,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.746,
    y: 185.286,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.746,
    y: 191.118,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.746,
    y: 194.034,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.746,
    y: 202.782,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.746,
    y: 205.698,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.746,
    y: 208.614,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.746,
    y: 211.53,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.746,
    y: 214.446,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.746,
    y: 217.363,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.746,
    y: 220.279,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.983,
    y: 170.706,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.983,
    y: 173.622,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.983,
    y: 176.538,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.983,
    y: 179.454,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.983,
    y: 182.37,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.983,
    y: 185.286,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.983,
    y: 194.034,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.983,
    y: 196.95,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.983,
    y: 199.866,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.983,
    y: 202.782,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.983,
    y: 205.698,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.983,
    y: 208.614,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.983,
    y: 211.53,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.983,
    y: 214.446,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.983,
    y: 217.363,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.983,
    y: 220.279,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.983,
    y: 223.195,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.983,
    y: 229.027,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.22,
    y: 170.706,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.22,
    y: 173.622,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.22,
    y: 176.538,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.22,
    y: 179.454,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.22,
    y: 182.37,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.22,
    y: 185.286,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.22,
    y: 194.034,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.22,
    y: 196.95,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.22,
    y: 199.866,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.22,
    y: 202.782,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.22,
    y: 211.53,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.22,
    y: 214.446,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.22,
    y: 217.363,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.22,
    y: 220.279,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.22,
    y: 223.195,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.22,
    y: 229.027,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.22,
    y: 231.943,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.152,
    y: 197.82,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.152,
    y: 200.736,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.152,
    y: 203.652,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.152,
    y: 206.568,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.152,
    y: 209.484,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.152,
    y: 212.4,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.152,
    y: 215.316,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.152,
    y: 224.064,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.152,
    y: 226.98,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.152,
    y: 229.896,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.39,
    y: 197.82,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.39,
    y: 200.736,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.39,
    y: 203.652,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.39,
    y: 206.568,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.39,
    y: 209.484,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.39,
    y: 212.4,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.39,
    y: 215.316,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.869,
    y: 197.82,
    style: {
      fill: "#FAFAFA"
    },
    width: 2.498,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.869,
    y: 200.736,
    style: {
      fill: "#FAFAFA"
    },
    width: 2.498,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.869,
    y: 203.652,
    style: {
      fill: "#FAFAFA"
    },
    width: 2.498,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.869,
    y: 206.568,
    style: {
      fill: "#FAFAFA"
    },
    width: 2.498,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.869,
    y: 209.484,
    style: {
      fill: "#FAFAFA"
    },
    width: 2.498,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.869,
    y: 212.4,
    style: {
      fill: "#FAFAFA"
    },
    width: 2.498,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.869,
    y: 215.316,
    style: {
      fill: "#FAFAFA"
    },
    width: 2.498,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.569,
    y: 201.605,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.569,
    y: 204.522,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.569,
    y: 207.438,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.569,
    y: 210.354,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.569,
    y: 213.27,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.569,
    y: 216.186,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.569,
    y: 219.102,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.569,
    y: 222.018,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.569,
    y: 224.934,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.569,
    y: 227.85,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.569,
    y: 230.766,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.569,
    y: 233.682,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.569,
    y: 236.598,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.569,
    y: 239.514,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.569,
    y: 242.43,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.569,
    y: 245.346,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.569,
    y: 248.262,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.569,
    y: 251.178,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.569,
    y: 254.095,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.569,
    y: 257.011,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.807,
    y: 201.605,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.807,
    y: 204.522,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.807,
    y: 207.438,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.807,
    y: 210.354,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.807,
    y: 213.27,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.807,
    y: 216.186,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.807,
    y: 219.102,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.807,
    y: 222.018,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.807,
    y: 224.934,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.807,
    y: 227.85,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.807,
    y: 230.766,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.807,
    y: 233.682,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.807,
    y: 236.598,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.807,
    y: 239.514,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.807,
    y: 242.43,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.807,
    y: 245.346,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.807,
    y: 248.262,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.807,
    y: 251.178,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.044,
    y: 201.605,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.044,
    y: 204.522,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.044,
    y: 207.438,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.044,
    y: 210.354,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.044,
    y: 213.27,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.044,
    y: 216.186,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.044,
    y: 219.102,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.044,
    y: 222.018,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.044,
    y: 224.934,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.044,
    y: 227.85,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.044,
    y: 230.766,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.044,
    y: 233.682,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.044,
    y: 236.598,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.044,
    y: 239.514,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.044,
    y: 242.43,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.044,
    y: 245.346,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.044,
    y: 248.262,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.044,
    y: 251.178,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.904,
    y: 222.888,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.904,
    y: 225.804,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.904,
    y: 228.72,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.904,
    y: 231.636,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.904,
    y: 234.552,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.904,
    y: 237.468,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.904,
    y: 240.384,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.904,
    y: 243.3,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.904,
    y: 246.216,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.904,
    y: 249.132,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.904,
    y: 252.048,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.904,
    y: 254.964,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.904,
    y: 257.88,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.141,
    y: 222.888,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.141,
    y: 225.804,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.141,
    y: 228.72,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.141,
    y: 231.636,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.141,
    y: 234.552,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.141,
    y: 237.468,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.141,
    y: 240.384,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.141,
    y: 243.3,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.141,
    y: 246.216,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.141,
    y: 249.132,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.141,
    y: 252.048,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.141,
    y: 254.964,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.141,
    y: 257.88,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.378,
    y: 222.888,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.378,
    y: 225.804,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.378,
    y: 228.72,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.378,
    y: 231.636,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.378,
    y: 234.552,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.378,
    y: 237.468,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.378,
    y: 240.384,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.378,
    y: 243.3,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.378,
    y: 246.216,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.378,
    y: 249.132,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.378,
    y: 252.048,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.378,
    y: 254.964,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.378,
    y: 257.88,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.378,
    y: 260.797,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.031,
    y: 223.757,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.031,
    y: 226.673,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.031,
    y: 229.589,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.031,
    y: 232.506,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.031,
    y: 235.422,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.031,
    y: 238.338,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.031,
    y: 241.254,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.031,
    y: 244.17,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.031,
    y: 247.086,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.031,
    y: 250.002,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.031,
    y: 258.75,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.268,
    y: 223.757,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.268,
    y: 226.673,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.268,
    y: 229.589,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.268,
    y: 232.506,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.268,
    y: 235.422,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.268,
    y: 238.338,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.268,
    y: 241.254,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.268,
    y: 244.17,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.268,
    y: 247.086,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.268,
    y: 255.834,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.268,
    y: 258.75,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.505,
    y: 223.757,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.505,
    y: 226.673,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.505,
    y: 229.589,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.505,
    y: 232.506,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.505,
    y: 235.422,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.505,
    y: 238.338,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.505,
    y: 241.254,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.505,
    y: 244.17,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.505,
    y: 252.918,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.505,
    y: 255.834,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.505,
    y: 258.75,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 179.454,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 182.37,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 185.286,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 188.202,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 191.118,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 194.034,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 196.95,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 199.866,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 202.782,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 205.698,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 208.614,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 211.53,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 214.446,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 217.363,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 220.279,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 223.195,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 226.111,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 231.943,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 234.859,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 237.775,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 240.691,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.824,
    y: 243.607,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.061,
    y: 179.454,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.061,
    y: 182.37,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.061,
    y: 185.286,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.061,
    y: 188.202,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.061,
    y: 191.118,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.061,
    y: 194.034,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.061,
    y: 196.95,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.061,
    y: 199.866,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.061,
    y: 202.782,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.061,
    y: 205.698,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.061,
    y: 208.614,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.061,
    y: 211.53,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.061,
    y: 214.446,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.061,
    y: 217.363,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.061,
    y: 220.279,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.061,
    y: 223.195,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.061,
    y: 240.691,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.061,
    y: 243.607,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.298,
    y: 179.454,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.298,
    y: 182.37,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.298,
    y: 185.286,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.298,
    y: 188.202,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.298,
    y: 191.118,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.298,
    y: 194.034,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.298,
    y: 196.95,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.298,
    y: 199.866,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.298,
    y: 202.782,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.298,
    y: 205.698,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.298,
    y: 208.614,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.298,
    y: 211.53,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.298,
    y: 214.446,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.298,
    y: 217.363,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.298,
    y: 220.279,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.298,
    y: 223.195,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.298,
    y: 229.027,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.298,
    y: 231.943,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.298,
    y: 234.859,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.298,
    y: 237.775,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.298,
    y: 243.607,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.851,
    y: 216.186,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.851,
    y: 219.102,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.851,
    y: 222.018,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.851,
    y: 224.934,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.851,
    y: 227.85,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.851,
    y: 230.766,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.851,
    y: 233.682,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.851,
    y: 239.514,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.851,
    y: 242.43,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.851,
    y: 245.346,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.851,
    y: 248.262,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.851,
    y: 251.178,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.851,
    y: 254.095,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.851,
    y: 257.011,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.851,
    y: 259.927,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.088,
    y: 216.186,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.088,
    y: 219.102,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.088,
    y: 222.018,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.088,
    y: 224.934,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.088,
    y: 227.85,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.088,
    y: 230.766,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.088,
    y: 239.514,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.088,
    y: 242.43,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.088,
    y: 245.346,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.088,
    y: 248.262,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.088,
    y: 251.178,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.088,
    y: 254.095,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.088,
    y: 257.011,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.088,
    y: 259.927,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.326,
    y: 216.186,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.326,
    y: 219.102,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.326,
    y: 222.018,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.326,
    y: 224.934,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.326,
    y: 227.85,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.326,
    y: 230.766,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.326,
    y: 236.598,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.326,
    y: 239.514,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.326,
    y: 242.43,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.326,
    y: 245.346,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.326,
    y: 248.262,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.326,
    y: 251.178,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.326,
    y: 254.095,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.326,
    y: 257.011,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.326,
    y: 259.927,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.107,
    y: 199.866,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.107,
    y: 202.782,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.107,
    y: 205.698,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.107,
    y: 208.614,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.107,
    y: 211.53,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.107,
    y: 214.446,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.107,
    y: 217.363,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.107,
    y: 220.279,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.107,
    y: 223.195,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.107,
    y: 226.111,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.107,
    y: 229.027,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.107,
    y: 231.943,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.107,
    y: 234.859,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.107,
    y: 240.691,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.107,
    y: 243.607,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.107,
    y: 246.523,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.107,
    y: 249.439,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.107,
    y: 255.271,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.107,
    y: 258.187,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.107,
    y: 261.103,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.344,
    y: 199.866,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.344,
    y: 202.782,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.344,
    y: 205.698,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.344,
    y: 208.614,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.344,
    y: 211.53,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.344,
    y: 214.446,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.344,
    y: 217.363,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.344,
    y: 220.279,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.344,
    y: 223.195,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.344,
    y: 226.111,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.344,
    y: 229.027,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.344,
    y: 231.943,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.344,
    y: 234.859,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.344,
    y: 243.607,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.344,
    y: 246.523,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.344,
    y: 252.355,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.344,
    y: 255.271,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.344,
    y: 258.187,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.344,
    y: 261.103,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.582,
    y: 199.866,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.582,
    y: 202.782,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.582,
    y: 205.698,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.582,
    y: 208.614,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.582,
    y: 211.53,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.582,
    y: 214.446,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.582,
    y: 217.363,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.582,
    y: 220.279,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.582,
    y: 223.195,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.582,
    y: 226.111,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.582,
    y: 229.027,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.582,
    y: 231.943,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.582,
    y: 234.859,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.582,
    y: 237.775,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.582,
    y: 243.607,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.582,
    y: 249.439,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.582,
    y: 252.355,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.582,
    y: 255.271,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.582,
    y: 258.187,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.582,
    y: 261.103,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.362,
    y: 216.493,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.362,
    y: 219.409,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.362,
    y: 222.325,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.362,
    y: 225.241,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.362,
    y: 228.157,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.362,
    y: 231.073,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.362,
    y: 239.821,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.362,
    y: 242.737,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.362,
    y: 245.653,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.362,
    y: 248.57,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.362,
    y: 251.486,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.362,
    y: 254.402,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.362,
    y: 257.318,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.74,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.599,
    y: 216.493,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.599,
    y: 219.409,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.599,
    y: 222.325,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.599,
    y: 225.241,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.599,
    y: 228.157,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.599,
    y: 231.073,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.599,
    y: 239.821,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.599,
    y: 242.737,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.599,
    y: 245.653,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.599,
    y: 248.57,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.599,
    y: 251.486,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.599,
    y: 254.402,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.599,
    y: 260.234,
    style: {
      fill: "#FAFAFA"
    },
    width: 1.739,
    height: 1.739
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 254.389,
    y: 121.142,
    style: {
      fill: "#EBEBEB"
    },
    width: 3.454,
    height: 189.487
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.84,
    y: 121.142,
    style: {
      fill: "#EBEBEB"
    },
    width: 2.922,
    height: 189.487
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.76,
    y: 121.142,
    style: {
      fill: "#EBEBEB"
    },
    width: 2.922,
    height: 189.487
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M78.816,358.717c0,0-4.462-9.735,0.636-19.331c5.098-9.596,6.575-11.857,3.326-13.823 c-3.25-1.966-4.74,7.677-4.74,7.677s-2.739-6.634-0.478-13.577c2.262-6.943,3.68-18.25,0.591-19.463 c-3.089-1.213-0.59,14.107-3.27,19.328c0,0-2.251-5.813-2.622-11.389c-0.37-5.576,0.208-14.481-2.231-16.765 c-2.439-2.284-4.002-0.704-1.605,11.602c2.397,12.306,2.379,22.309,2.379,22.309s-5.294-16.143-8.848-16.613 c-3.553-0.471-3.549,4.757-0.507,9.291c3.042,4.534,8.907,12.657,9.869,16.837c0,0-5.812-12.148-11.039-8.425 c-5.228,3.723,4.55,11.061,8.908,13.712c4.358,2.651,7.384,19.271,7.384,19.271L78.816,358.717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M75.294,362.709c0,0,4.344-9.8-0.868-19.32c-5.212-9.52-6.717-11.758-3.491-13.772 c3.226-2.014,4.832,7.605,4.832,7.605s2.66-6.674,0.314-13.582c-2.345-6.908-3.899-18.194-0.825-19.453 c3.074-1.259,0.759,14.096,3.501,19.278c0,0,2.181-5.846,2.485-11.427c0.304-5.581-0.382-14.476,2.03-16.796 c2.411-2.32,3.993-0.763,1.744,11.577c-2.249,12.341-2.112,22.343-2.112,22.343s5.1-16.22,8.648-16.744 c3.547-0.524,3.605,4.704,0.619,9.283c-2.987,4.579-8.755,12.789-9.666,16.983c0,0,5.665-12.233,10.937-8.589 c5.272,3.645-4.417,11.128-8.743,13.844c-4.326,2.716-7.152,19.38-7.152,19.38L75.294,362.709z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "95.332,355.723 59.442,355.723 62.347,381.406 92.427,381.406  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M421.859,353.894c0.129-0.871,3.105-21.404-2.856-28.493c-1.319-1.569-2.985-2.389-4.95-2.438 c-12.034-0.282-13.68,9.384-13.695,9.482l1.419,0.219c0.055-0.346,1.482-8.526,12.241-8.266 c1.557,0.038,2.828,0.668,3.886,1.926c5.55,6.599,2.566,27.15,2.535,27.357L421.859,353.894z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M422.587,352.958l1.435-0.045c-0.006-0.189-0.477-18.919,8.752-22.789 c9.045-3.789,13.113,4.001,13.282,4.336l1.283-0.645c-0.047-0.093-4.821-9.333-15.12-5.014 C422.081,333.051,422.561,352.148,422.587,352.958z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M422.545,354.43c0-0.299,0.086-29.922,5.862-38.586c5.546-8.318,14.491-4.402,14.869-4.23 l0.594-1.308c-0.104-0.047-10.427-4.604-16.658,4.742c-6.016,9.024-6.103,38.146-6.103,39.382L422.545,354.43z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M412.331,323.676c0,0,5.254,1.937,3.692,6.51c-1.562,4.573-18.177,12.1-18.177,12.1 s-6.959-6.378-0.568-16.751C403.668,315.161,412.189,320.403,412.331,323.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M428.667,314.284c0,0-3.73-0.401-3.43-2.673c0.3-2.272,14.501-8.12,22.88,1.336 c0,0-5.365,9.215-13.12,9.336C427.242,322.404,428.667,314.284,428.667,314.284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M432.496,329.463c0,0-2.575-2.079,0.204-3.093c2.778-1.015,16.411-0.726,16.553,12.778 c0,0-15.878,2.639-17.843-2.505C429.445,331.498,432.496,329.463,432.496,329.463z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "409.507,381.406 434.147,381.406 436.805,354.429 406.849,354.429  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.534,
    y: 351.453,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 843.6539 708.858)",
    style: {
      fill: "#E0E0E0"
    },
    width: 32.587,
    height: 5.953
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E0E0E0"
    },
    cx: 159.264,
    cy: 119.256,
    r: 14.168
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 159.264,
    cy: 119.256,
    r: 12.046
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#F0F0F0",
      stroke: "#E0E0E0",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 159.833,110.992 159.833,119.413 165.413,116.256  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M244.751,83.663c21.853,2.553,48.442,12.925,63.789,29.752 c11.572,12.688,18.426,28.757,21.02,45.635c4.19,27.256-11.424,65,14.11,85.385c11.777,9.402,28.293,9.154,42.686,13.621 c18.732,5.813,34.628,20.843,40.366,39.598s0.619,40.698-13.629,54.177c-9.822,9.292-23.036,14.227-36.295,16.875 c-33.94,6.779-70.475-0.547-99.177-19.887c-10.944-7.375-21.843-16.792-35.038-17.06c-7.138-0.145-14.009,2.484-20.63,5.154 c-26.848,10.827-57.896,21.932-87.183,15.532c-75.415-16.481-77.325-122.615-58.715-180.913c1.475-4.62,3.155-8.988,5.423-13.284 c16.095-30.493,45.569-52.691,78.111-64.088C184.507,85.433,215.701,80.27,244.751,83.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M244.751,83.663c21.853,2.553,48.442,12.925,63.789,29.752 c11.572,12.688,18.426,28.757,21.02,45.635c4.19,27.256-11.424,65,14.11,85.385c11.777,9.402,28.293,9.154,42.686,13.621 c18.732,5.813,34.628,20.843,40.366,39.598s0.619,40.698-13.629,54.177c-9.822,9.292-23.036,14.227-36.295,16.875 c-33.94,6.779-70.475-0.547-99.177-19.887c-10.944-7.375-21.843-16.792-35.038-17.06c-7.138-0.145-14.009,2.484-20.63,5.154 c-26.848,10.827-57.896,21.932-87.183,15.532c-75.415-16.481-77.325-122.615-58.715-180.913c1.475-4.62,3.155-8.988,5.423-13.284 c16.095-30.493,45.569-52.691,78.111-64.088C184.507,85.433,215.701,80.27,244.751,83.663z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__359_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 416.238,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Board"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 79.667,
    y: 168.573,
    style: {
      fill: "#263238"
    },
    width: 152.863,
    height: 102.577
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "114.196,225.133 109.537,225.133 109.537,403.835 99.352,406.004 99.352,407.803  111.036,407.803 112.697,407.803 124.382,407.803 124.382,406.004 114.196,403.835  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "202.66,403.835 202.66,225.133 198.001,225.133 198.001,403.835 187.815,406.004  187.815,407.803 199.499,407.803 201.161,407.803 212.845,407.803 212.845,406.004  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.667,
    y: 168.573,
    style: {
      fill: "#FFFFFF"
    },
    width: 152.863,
    height: 102.577
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "114.196,225.133 109.537,225.133 109.537,403.835 99.352,406.004 99.352,407.803  111.036,407.803 112.697,407.803 124.382,407.803 124.382,406.004 114.196,403.835  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "202.66,403.835 202.66,225.133 198.001,225.133 198.001,403.835 187.815,406.004  187.815,407.803 199.499,407.803 201.161,407.803 212.845,407.803 212.845,406.004  "
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 109.233,
    y: 147.853,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 375.9599 63.763)",
    style: {
      fill: "#FFFFFF"
    },
    width: 93.731,
    height: 144.016
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "217.17,260.08 92.852,260.08 92.852,190.379 93.852,190.379 93.852,259.08 217.17,259.08  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 99.352,
    y: 248.512,
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 5.373,
    height: 10.068
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.352,
    y: 248.512,
    style: {
      fill: "#407BFF"
    },
    width: 5.373,
    height: 2.931
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 110.322,
    y: 232.405,
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 5.373,
    height: 26.175
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.322,
    y: 232.405,
    style: {
      fill: "#407BFF"
    },
    width: 5.373,
    height: 7.621
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 121.293,
    y: 238.444,
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 5.373,
    height: 20.136
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.293,
    y: 238.444,
    style: {
      fill: "#407BFF"
    },
    width: 5.373,
    height: 5.863
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 132.264,
    y: 229.186,
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 5.373,
    height: 29.393
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.264,
    y: 229.186,
    style: {
      fill: "#407BFF"
    },
    width: 5.373,
    height: 8.558
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 143.234,
    y: 220.642,
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 5.373,
    height: 37.937
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.234,
    y: 220.642,
    style: {
      fill: "#407BFF"
    },
    width: 5.373,
    height: 11.046
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 154.205,
    y: 214.178,
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 5.373,
    height: 44.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.205,
    y: 214.178,
    style: {
      fill: "#407BFF"
    },
    width: 5.373,
    height: 12.928
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 165.176,
    y: 221.653,
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 5.373,
    height: 36.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.176,
    y: 221.653,
    style: {
      fill: "#407BFF"
    },
    width: 5.373,
    height: 10.752
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 176.147,
    y: 220.041,
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 5.373,
    height: 38.538
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.147,
    y: 220.041,
    style: {
      fill: "#407BFF"
    },
    width: 5.373,
    height: 11.221
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 187.117,
    y: 210.207,
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 5.373,
    height: 48.373
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.117,
    y: 210.207,
    style: {
      fill: "#407BFF"
    },
    width: 5.373,
    height: 14.085
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 198.088,
    y: 200.297,
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 5.373,
    height: 58.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.088,
    y: 200.297,
    style: {
      fill: "#407BFF"
    },
    width: 5.373,
    height: 16.97
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 209.059,
    y: 191.632,
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 5.373,
    height: 66.948
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.059,
    y: 191.632,
    style: {
      fill: "#407BFF"
    },
    width: 5.373,
    height: 19.493
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 121.293,
    y: 179.855,
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 66.522,
    height: 2.765
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB376"
    },
    d: "M226.322,248.097l-4.648-2.281c0,0-1.385-3.058-1.484-3.009c-0.099,0.049-8.901-1.814-8.901-1.814 s-0.099,5.196,0.89,6.299s7.022,1.618,7.318,1.805c0.297,0.188,0.989-0.432,0.989-0.432l4.945,3.247L226.322,248.097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M277.124,208.977c0,0-1.928-4.45-8.159-4.45c-6.231,0-11.423,3.709-11.126,8.456 c0.297,4.747-3.264,4.302-3.857,8.901s1.632,5.786,1.78,7.714c0.148,1.928-2.374,1.335-4.005,4.599 c-1.632,3.264-3.709,7.863,3.264,13.945c6.972,6.082,26.703,5.044,31.005,1.335c4.302-3.709,4.154-10.829,0-12.758 c-4.154-1.929-0.297-1.632,0.148-5.934c0.445-4.302-3.412-5.934-3.115-9.346C283.355,218.027,284.393,209.274,277.124,208.977z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M252.91,237.842v12.232c0,0-1.05,1.312-2.617,2.992c-1.485,1.59-3.45,3.51-5.422,4.942 c-1.875,1.358-3.765,2.288-5.295,2.093c-4.845-0.623-17.902-8.13-17.902-8.13l2.175-5.767c0,0,14.835,7.627,15.727,6.84 C240.468,252.257,250.218,238.54,252.91,237.842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M250.293,253.067c-1.485,1.59-3.45,3.51-5.422,4.942 c-0.705-5.46,5.557-12.195,5.557-12.195S250.518,249.317,250.293,253.067z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB376"
    },
    d: "M254.626,282.143c0,0-8.128,43.323-10.297,61.109c-2.833,23.204-14.42,57.15-14.42,57.15 l4.633,1.198c0,0,16.335-28.846,19.52-54.802c12.975-26.526,14.023-59.191,14.023-59.191L254.626,282.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M221.282,410.904c0.75-0.345,1.557-0.55,2.38-0.605l0,0c0,0,2.848-1.677,5.672-8.19l3.175-0.018 c1.099,0.013,2.073,0.71,2.439,1.747c0.052,0.141,0.082,0.289,0.09,0.44c-0.032,0.767-0.113,1.531-0.244,2.288 c-0.286,2.375-1.856,7.469-1.856,7.469l-0.538-0.137l0.978-4.737c0.325-1.61-1.366-0.055-2.15,1.568 c-0.784,1.623-1.988,3.256-5.494,2.455C221.648,412.227,220.001,411.639,221.282,410.904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB376"
    },
    d: "M263.067,281.452c0,0,1.009,44.067,2.566,61.918c2.027,23.288-2.288,58.897-2.288,58.897 l4.78,0.213c0,0,10.016-31.601,7.763-57.655c7.208-28.636,1.477-60.811,1.477-60.811L263.067,281.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M255.905,412.354c0.708-0.424,1.488-0.715,2.301-0.858l0,0c0,0,2.65-1.975,4.753-8.755l3.154-0.361 c1.094-0.106,2.138,0.482,2.613,1.473c0.067,0.135,0.113,0.279,0.137,0.427c0.051,0.766,0.053,1.535,0.005,2.301 c-0.027,2.392-1.038,7.626-1.038,7.626l-0.55-0.078l0.46-4.815c0.149-1.635-1.364,0.093-1.968,1.791 c-0.604,1.698-1.624,3.452-5.196,3.034C256.412,413.63,254.711,413.223,255.905,412.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB376"
    },
    d: "M229.908,400.402c0,0-3.964,8.295-6.246,9.896c0,0,3.06,1.825,6.246-2.237 c4.12-5.252,5.129-3.785,5.129-3.785s-0.175-1.797-0.496-2.677C233.922,399.905,229.908,400.402,229.908,400.402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB376"
    },
    d: "M263.831,400.334c0,0-1.125,3.071-2.625,6.446c-1.5,3.375-3,4.715-3,4.715s2.605,0.846,4.012-0.788 c1.406-1.634,3.812-7.534,6.509-6.855c0,0-0.198-0.704-0.602-1.372C267.721,401.811,263.831,400.334,263.831,400.334z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M251.842,274.913c0,0-3.218,32.069-7.998,64.223c-4.352,29.274-12.857,53.999-12.857,53.999 l9.494,0.791c0,0,18.197-45.098,23.736-71.207c0,0,1.978,46.285-1.187,71.999l8.308-0.396c0,0,20.272-87.105,5.143-118.481 L251.842,274.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M271.338,394.326l-8.31,0.39 c3.165-25.709,1.193-71.998,1.193-71.998c-1.402,6.592-3.608,14.385-6.12,22.365c-7.447,23.632-17.617,48.846-17.617,48.846 l-9.495-0.795c0,0,8.505-24.72,12.855-53.999c4.785-32.152,8.002-64.221,8.002-64.221l24.637,0.93 C291.61,307.215,271.338,394.326,271.338,394.326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M264.22,322.717c-1.402,6.592-3.608,14.385-6.12,22.365 c-0.96-15.015,2.857-41.947,2.857-41.947L264.22,322.717z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "276.427,274.284 276.495,277.907 251.714,276.477 251.633,272.193  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.22,
    y: 273.154,
    transform: "matrix(-0.9975 -0.0704 0.0704 -0.9975 499.8642 568.0351)",
    style: {
      fill: "#FFFFFF"
    },
    width: 5.433,
    height: 4.121
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 267.99,
    y: 272.936,
    transform: "matrix(-0.9995 -0.0321 0.0321 -0.9995 528.1995 560.6219)",
    style: {
      fill: "#407BFF"
    },
    width: 1.229,
    height: 6.261
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.99,
    y: 272.936,
    transform: "matrix(-0.9995 -0.0321 0.0321 -0.9995 528.1995 560.6219)",
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 1.229,
    height: 6.261
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 252.842,
    y: 271.562,
    transform: "matrix(-0.9995 -0.0321 0.0321 -0.9995 497.976 557.3683)",
    style: {
      fill: "#407BFF"
    },
    width: 1.229,
    height: 6.261
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.842,
    y: 271.562,
    transform: "matrix(-0.9995 -0.0321 0.0321 -0.9995 497.976 557.3683)",
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 1.229,
    height: 6.261
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M251.683,272.651l24.744,1.633c0.39-6.15,0.834-8.04,2.686-15.374 c0.592-2.37,1.335-5.017,2.288-8.077c0.51-1.635,1.073-3.39,1.703-5.28c0.473-1.432,0.982-2.955,1.545-4.56 c-3.367-1.072-6.795-1.905-10.275-2.482c-3.668-0.652-7.387-1.042-11.115-1.17c-4.815-0.038-10.35,0.503-10.35,0.503 s-0.787,0.188-1.282,5.295C251.176,247.93,250.693,255.214,251.683,272.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M251.683,272.651l24.744,1.633 c0.39-6.15,0.834-8.04,2.686-15.374c0.592-2.37,1.335-5.017,2.288-8.077c0.51-1.635,1.073-3.39,1.703-5.28 c0.473-1.432,0.982-2.955,1.545-4.56c-3.367-1.072-6.795-1.905-10.275-2.482c-3.668-0.652-7.387-1.042-11.115-1.17 c-4.815-0.038-10.35,0.503-10.35,0.503s-0.787,0.188-1.282,5.295C251.176,247.93,250.693,255.214,251.683,272.651z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB376"
    },
    d: "M265.302,242.807c6.101-0.781,7.934-3.387,7.934-3.387c-3.871-3.652-0.655-9.981-0.655-9.981 l-7.344,1.371c0.193,1.213,0.275,2.232,0.287,3.091c0.056,4.457-1.96,4.501-1.96,4.501 C262.276,240.817,265.302,242.807,265.302,242.807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M265.237,230.81c0.193,1.213,0.275,2.232,0.287,3.091 c4.96,0,7.057-4.463,7.057-4.463L265.237,230.81z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB376"
    },
    d: "M269.297,210.277c-6.383-0.35-8.625,2.955-9.453,9.508c-1.035,8.189,0.468,14.129,8.546,12.811 C279.36,230.805,279.898,210.857,269.297,210.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D58745"
    },
    d: "M263.99,219.654c0,0-0.976,1.619-2.002,2.546c0,0,0.499,0.898,1.643,0.814L263.99,219.654z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M267.925,219.346c-0.041,0.524,0.209,0.97,0.558,0.998c0.349,0.027,0.665-0.375,0.706-0.899 c0.041-0.524-0.209-0.971-0.558-0.998C268.283,218.42,267.966,218.822,267.925,219.346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M268.776,218.484l-1.104-0.536C267.672,217.948,268.164,218.951,268.776,218.484z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M261.424,218.727c-0.041,0.524,0.209,0.97,0.558,0.998c0.349,0.027,0.665-0.375,0.706-0.899 c0.041-0.524-0.209-0.97-0.558-0.998S261.465,218.204,261.424,218.727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M262.274,217.865l-1.104-0.536C261.17,217.329,261.662,218.332,262.274,217.865z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2E353A",
      strokeWidth: 0.7247,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M268.231,214.941c0,0,1.806-0.135,2.716,1.117"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2E353A",
      strokeWidth: 0.7247,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M263.606,214.417c0,0-1.105-0.479-2.573,0.385"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M264.424,225.576c0.327,0.79,0.623,2.258,0.623,2.258c0.138-0.003,0.276-0.006,0.413-0.016 c1.868-0.086,2.707-0.743,3.069-1.446c0.197-0.385,0.247-0.788,0.245-1.115c0.001-0.378-0.084-0.648-0.084-0.648 c-0.963,0.637-2.699,0.852-3.63,0.927C264.67,225.573,264.424,225.576,264.424,225.576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M265.06,225.537l0.201,0.661c1.759-0.085,2.987-0.382,3.513-0.94 c0.001-0.378-0.084-0.648-0.084-0.648C267.728,225.247,265.992,225.461,265.06,225.537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE5753"
    },
    d: "M265.46,227.818c1.868-0.086,2.707-0.743,3.069-1.446c-0.635,0.054-1.396,0.189-2.056,0.507 C265.968,227.12,265.66,227.469,265.46,227.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M275.684,221.418c0,0-2.697-5.408-2.023-9.432c0,0-12.367-5.861-13.695,6.945 c0,0-0.611-11.469,10.376-11.122c10.97,0.346,10.061,16.398,4.132,20.871C274.474,228.68,277.351,224.799,275.684,221.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M276.333,209.669c0,0-4.994-4.45-9.544-3.61c-4.549,0.841-3.758,6.824,2.225,9.099 s7.22,5.192,7.22,5.192l5.192-4.648L276.333,209.669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M265.454,207.931c0,0-2.126,0.148-1.533,3.313 c0.593,3.165,5.093,4.755,9.346,6.239c4.253,1.484,3.906,3.157,3.906,3.157"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB376"
    },
    d: "M274.568,222.708c0.099-1.025,1.255-2.707,3.155-2.394c1.966,0.324,2.687,4.437-2.287,5.144 C274.722,225.559,274.361,224.848,274.568,222.708z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB376"
    },
    d: "M278.892,240.096c0,0-7.163,5.812-13.832,5.719c-6.669-0.094-9.013-7.594-9.013-7.594 S266.391,235.159,278.892,240.096z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M284.65,240.992l-3.225,38.617l-6.915,0.577c-1.02-5.25-1.2-13.545-1.065-21.359v-0.007 c0.18-10.605,0.93-20.31,0.93-20.31C278.215,238.915,284.65,240.992,284.65,240.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M275.477,248.199l1.868,2.865l-3.9,7.755 c0.18-10.605,0.93-20.31,0.93-20.31l5.947,5.535L275.477,248.199z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M261.033,237.28l-0.008,0.007c-0.158,0.285-3.6,6.54-6.337,18.525 c-1.357,5.955-2.535,13.335-3.053,22.095l-2.64-1.223c0,0-1.245-29.909,3.915-38.842L261.033,237.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M261.025,237.287c-0.158,0.285-3.6,6.54-6.337,18.525 l-1.23-7.717l2.588-2.28l-2.588-4.935L261.025,237.287z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M294.662,264.317c-0.773,1.657-2.1,1.815-3.465,1.14c-1.08-0.533-2.19-1.598-3.06-2.85 c-0.623-0.892-1.455-2.235-2.31-3.652c-1.83-3.067-3.735-6.472-3.735-6.472l2.557-11.49 C288.332,242.755,296.042,261.347,294.662,264.317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M291.197,265.457c-1.08-0.533-2.19-1.598-3.06-2.85 c-0.623-0.892-1.455-2.235-2.31-3.652c1.05-1.927,2.168-3.45,2.168-3.45l1.86,5.227c0,0,3.262,0.742,3.78,2.445 C293.83,263.822,292.72,264.737,291.197,265.457z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M291.085,250.515L284.922,274c-0.144,0.55-0.723,0.938-1.288,0.862l-16.347-2.178 c-0.565-0.075-0.908-0.586-0.764-1.136l6.163-23.484c0.144-0.55,0.723-0.938,1.288-0.862l16.348,2.178 C290.887,249.455,291.23,249.965,291.085,250.515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    d: "M291.085,250.515L284.922,274c-0.144,0.55-0.723,0.938-1.288,0.862l-15.604-2.079 c-0.565-0.075-0.908-0.586-0.764-1.136l6.164-23.484c0.144-0.55,0.723-0.938,1.288-0.862l15.604,2.079 C290.887,249.455,291.23,249.965,291.085,250.515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M279.738,259.47c-0.812-0.108-1.639,0.445-1.846,1.236 c-0.208,0.791,0.282,1.52,1.094,1.628c0.812,0.108,1.639-0.445,1.846-1.236C280.021,260.99,279.53,260.261,279.738,259.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M292.412,269.852c-1.103,0.585-3.585-0.3-4.342-0.6c-0.15-0.052-0.233-0.09-0.233-0.09 s-1.357-4.425,2.175-6.817c0.022-0.015,0.052-0.037,0.082-0.045c1.125-0.608,4.612,0.172,4.717,1.35 C295.232,268.374,293.725,269.161,292.412,269.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M290.26,266.072c-0.427,1.598-1.365,2.587-2.19,3.18 c-0.15-0.052-0.233-0.09-0.233-0.09s-1.357-4.425,2.175-6.817c0.022-0.015,0.052-0.037,0.082-0.045 C290.402,262.697,290.882,263.747,290.26,266.072z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB376"
    },
    d: "M285.167,260.46c0,0,2.265-0.099,3.308,0c1.043,0.099,0.721,3.451,0.721,3.451l0.895,0.484 c0,0,0.726,1.974-0.833,2.965l-0.801-0.274c0,0-0.226,0.791-0.868,1.187c-0.642,0.396-3.807-0.495-3.807-0.495L285.167,260.46z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M192.962,293.366h-32.125l5.328-21.076c0.116-0.459,0.602-0.831,1.085-0.831h30.375 c0.483,0,0.781,0.372,0.665,0.831L192.962,293.366z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "192.723,291.608 161.965,291.608 166.641,273.11 197.4,273.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "192.723,291.608 161.965,291.608 166.641,273.11  197.4,273.11  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M178.961,292.692h-18.164h-14.001v1.338c0,0.573,0.464,1.037,1.037,1.037h12.964h18.164h12.964 c0.573,0,1.037-0.464,1.037-1.037v-1.338H178.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M178.961,292.692h-18.164h-14.001v1.338 c0,0.573,0.464,1.037,1.037,1.037h12.964h18.164h12.964c0.573,0,1.037-0.464,1.037-1.037v-1.338H178.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M163.901,292.692v0.462h-5.604v-0.462h-11.501v1.338 c0,0.573,0.464,1.037,1.037,1.037h30.092c0.573,0,1.037-0.464,1.037-1.037v-1.338H163.901z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "180.702,284.027 165.964,284.027  168.102,275.572 182.839,275.572  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "182.714,276.066 167.977,276.066 168.102,275.572 182.839,275.572  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "191.943,290.286 171.437,290.286 174.412,278.52  194.917,278.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "194.743,279.208 174.238,279.208 174.412,278.52 194.917,278.52  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "400.896,417.31 396.228,417.31 387.839,300.525 394.033,300.525  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "400.899,417.31 396.228,417.31 388.249,306.326  387.837,300.713 394.033,300.713 394.368,306.326  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "394.368,306.048 388.249,306.048 387.837,300.713  394.033,300.713  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "269.876,417.31 265.207,417.31 272.07,300.525 278.264,300.525  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "278.263,300.713 277.852,306.326 269.873,417.31  265.209,417.31 271.732,306.326 272.067,300.713  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "272.067,300.713 278.263,300.713 277.852,306.048  271.732,306.048  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "213.187,417.31 208.518,417.31 200.13,300.525 206.324,300.525  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "213.189,417.31 208.518,417.31 200.539,306.326  200.128,300.713 206.323,300.713 206.659,306.326  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "206.659,306.048 200.539,306.048 200.128,300.713  206.323,300.713  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "92.167,417.31 87.499,417.31 94.362,300.525 100.555,300.525  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "100.554,300.713 100.143,306.326 92.164,417.31  87.5,417.31 94.023,306.326 94.359,300.713  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "94.359,300.713 100.554,300.713 100.143,306.048  94.023,306.048  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M397.238,303.45H91.156c-0.941,0-1.704-0.763-1.704-1.704V297.6h309.49v4.145 C398.943,302.687,398.18,303.45,397.238,303.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M397.238,303.45H91.156c-0.941,0-1.704-0.763-1.704-1.704 V297.6h309.49v4.145C398.943,302.687,398.18,303.45,397.238,303.45z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 89.452,
    y: 297.6,
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 309.491,
    height: 2.925
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M401.836,298.363H86.558c-0.91,0-1.648-0.738-1.648-1.648l0,0c0-0.91,0.738-1.648,1.648-1.648 h315.278c0.91,0,1.648,0.738,1.648,1.648l0,0C403.484,297.625,402.746,298.363,401.836,298.363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M401.836,298.363H86.558c-0.91,0-1.648-0.738-1.648-1.648 l0,0c0-0.91,0.738-1.648,1.648-1.648h315.278c0.91,0,1.648,0.738,1.648,1.648l0,0 C403.484,297.625,402.746,298.363,401.836,298.363z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M298.158,293.366h32.125l-5.329-21.076c-0.116-0.459-0.602-0.831-1.085-0.831h-30.375 c-0.483,0-0.781,0.372-0.665,0.831L298.158,293.366z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "298.397,291.608 329.155,291.608 324.479,273.11 293.721,273.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "298.397,291.608 329.155,291.608 324.479,273.11  293.721,273.11  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M312.159,292.692h18.164h14.001v1.338c0,0.573-0.464,1.037-1.037,1.037h-12.964h-18.164h-12.964 c-0.573,0-1.037-0.464-1.037-1.037v-1.338H312.159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M312.159,292.692h18.164h14.001v1.338 c0,0.573-0.464,1.037-1.037,1.037h-12.964h-18.164h-12.964c-0.573,0-1.037-0.464-1.037-1.037v-1.338H312.159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M327.219,292.692v0.462h5.605v-0.462h11.501v1.338 c0,0.573-0.464,1.037-1.037,1.037h-30.091c-0.573,0-1.037-0.464-1.037-1.037v-1.338H327.219z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "299.746,290.249 327.347,290.249 323.343,274.412  295.742,274.412  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "295.976,275.338 323.577,275.338 323.343,274.412 295.742,274.412  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E__54_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M368.458,408.996l7.886-0.492c0.274-0.03,0.521,0.169,0.55,0.443c0,0.003,0,0.006,0.001,0.008 l0.774,6.221c0.042,0.68-0.47,1.268-1.15,1.318c-2.754,0.127-4.076,0.05-7.548,0.239c-2.13,0.127-6.328,0.58-9.267,0.296 c-2.939-0.285-2.579-3.182-1.31-3.321c3.01-0.343,6.997-2.555,8.88-4.233C367.604,409.189,368.021,409.021,368.458,408.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M328.275,408.996l7.886-0.492c0.274-0.03,0.52,0.169,0.55,0.443c0,0.003,0.001,0.006,0.001,0.008 l0.774,6.221c0.043,0.68-0.47,1.268-1.149,1.318c-2.754,0.127-4.076,0.05-7.548,0.239c-2.13,0.127-6.328,0.58-9.267,0.296 c-2.939-0.285-2.579-3.182-1.31-3.321c3.01-0.343,6.997-2.555,8.88-4.233C327.422,409.189,327.838,409.021,328.275,408.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB376"
    },
    d: "M357.891,290.068l-6.477,0.971c0,0-2.2-0.726-4.521-0.971c-2.322-0.244-5.01,0-5.01,0 s-2.933,1.1-2.933,3.911c0,0,6.843,1.833,9.47,0.733l9.47-0.733V290.068z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M373.261,265.371c-4.031,4.168-6.781,20.298-7.514,21.398c-0.733,1.1-14.664,3.116-14.664,3.116 s-1.467,3.046,0,5.557c0,0,17.264-0.791,19.355-1.891c2.091-1.1,7.232-13.144,7.232-13.144s0.487-3.169-0.677-8.302 C375.829,266.973,373.261,265.371,373.261,265.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M373.261,265.371c-4.031,4.168-6.781,20.298-7.514,21.398 c-0.733,1.1-14.664,3.116-14.664,3.116s-1.467,3.046,0,5.557c0,0,17.264-0.791,19.355-1.891 c2.091-1.1,7.232-13.144,7.232-13.144s0.487-3.169-0.677-8.302C375.829,266.973,373.261,265.371,373.261,265.371z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D58745"
    },
    d: "M342.64,243.161c0,0-0.864,2.368-1.971,3.843c0,0,0.882,1.048,2.358,0.646L342.64,243.161z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E353A"
    },
    d: "M341.546,242.017c0.08,0.696,0.521,1.217,0.985,1.163c0.464-0.053,0.775-0.661,0.695-1.357 c-0.08-0.696-0.521-1.217-0.985-1.163C341.777,240.714,341.466,241.321,341.546,242.017z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2E353A",
      strokeWidth: 0.7247,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M341.724,239.243c0,0,0.511-0.141,1.135,0.398"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB376"
    },
    d: "M344.471,250.999c0.167,0.306,0.341,0.603,0.532,0.881c1.129,1.685,2.709,2.908,4.46,3.603 c0.459,0.185,0.932,0.334,1.412,0.446c2.533,0.588,5.248,0.131,7.388-1.523c0.879-0.665,1.669-1.545,2.302-2.634 c2.517-4.267,1.432-8.184,0.127-14.951c-0.259-1.462-0.849-2.844-1.742-4.024c-3.112-4.172-9.021-5.022-13.184-1.911 C339.897,235.208,341.508,245.359,344.471,250.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M349.463,255.482c0.459,0.185,0.932,0.334,1.412,0.446 c2.533,0.588,5.248,0.131,7.388-1.523c-0.795-1.171-1.764-1.963-1.764-1.963S352.359,252.836,349.463,255.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB376"
    },
    d: "M368.865,260.17c-2.531,3.816-14.652,5.319-14.652,5.319s-5.372-0.106-4.714-1.943 c2.836-1.237,3.92-2.98,4.066-4.897c0.083-1.116-0.158-2.288-0.554-3.456c-0.201-0.616-0.456-1.227-0.725-1.825l8.09-9.884 C358.263,254.406,364.756,257.456,368.865,260.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M342.608,230.497c2.293-3.599,4.33-2.967,4.33-2.967c1.462-3.017,10.048-3.14,14.408-0.174 c4.36,2.966,5.882,8.533,5.593,12.95c-0.421,6.433-4.454,12.975-4.454,12.975c-0.002,0.001-0.003,0.001-0.005,0.002 c-5.074,1.353-9.327,0.24-9.654-2.446c-0.327-2.686-3.04-4.677-3.04-4.677c-2.497,0.843-4.758-1.941-4.758-1.941 s-2.832-2.499-2.072-5.956C343.716,234.805,340.675,233.53,342.608,230.497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB376"
    },
    d: "M350.693,244.386c-0.032,1.552-0.561,2.82-1.471,3.525c-1.213,0.92-2.589-0.769-2.899-2.824 c-0.263-1.824,0.025-4.559,1.563-4.596C349.422,240.454,350.713,242.473,350.693,244.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M346.258,244.49c0,0,0.689,5.831,2.257,8.152c1.568,2.321,1.38,3.112,3.53,3.479 c0,0-1.211,1.61-2.3,1.378c-1.088-0.232-0.842-1.154-1.807-1.139c-0.965,0.015-2.63-0.654-2.454-1.649 c0.175-0.996,0.365-1.269-0.907-2.13c-1.272-0.861-1.722-2.805-1.032-3.61c0.69-0.805,1.999-0.555,1.999-0.555l-0.101-4.342 L346.258,244.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M351.677,263.548c0,0,1.955-8.785,13.748-8.7l2.994,4.35L351.677,263.548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M351.677,263.548c0,0,1.955-8.785,13.748-8.7l2.994,4.35L351.677,263.548z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M353.654,372.302c4.465,16.976,11.507,38.877,11.507,38.877l12.359-0.944 c0,0-6.712-29.551-8.549-47.69c-1.138-11.197-1.036-20.464,2.241-21.18c2.064-0.455,6.892-0.438,13.076-0.295V318.02 c-17.356,3.564-34.627,10.287-35.941,15.679C346.509,341.29,349.719,357.356,353.654,372.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M353.654,372.302c4.617-2.924,10.017-6.361,15.317-9.756 c-1.138-11.197-1.036-20.464,2.241-21.18c2.064-0.455,6.892-0.438,13.076-0.295V318.02 c-17.356,3.564-34.627,10.287-35.941,15.679C346.509,341.29,349.719,357.356,353.654,372.302z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M360.715,311.158l-2.941-8.881c0,0-2.115-16.446-12.844-37.166c0,0,12.913-9.165,27.224-7.799 c11.011,1.051,21.371,29.279,24.614,51.622L360.715,311.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M396.77,308.935l-36.05,2.225l-2.95-8.88c0,0-0.36-2.813-1.54-7.578 c-0.82-3.275-2.02-7.484-3.77-12.333c-1.84-5.133-4.29-11-7.53-17.256c0,0,12.91-9.163,27.22-7.799 C383.17,258.363,393.53,286.588,396.77,308.935z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M360.415,315.755l-1.089-8.751l35.374-5.823c0,0,11.568,22.922,5.906,34.155 c-5.195,10.306-60.482,4.167-68.993,6.027c-8.597,1.879,5.786,68.722,5.786,68.722l-12.359,0.944 c0,0-20.216-61.118-16.289-77.325C310.464,326.63,339.609,317.268,360.415,315.755z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "395.998,305.163 379.607,307.312 379.077,304.896 395.496,302.507  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.713,304.909 377.912,307.312 362.764,309.395 362.764,307.021  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.824,307.152 361.824,309.395 359.626,309.689 359.626,307.52  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M356.23,295.48c-0.82-3.12-2.02-7.13-3.77-11.75 c0.63-1.3,1.49-2.45,2.59-3.32C355.05,280.41,358.44,291.44,356.23,295.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBB376"
    },
    d: "M327.579,292.551l-5.455-0.879c0,0-2.2-0.726-4.522-0.97c-2.322-0.245-5.01,0-5.01,0 s-2.933,1.1-2.933,3.91c0,0,6.843,1.833,9.471,0.733l8.054,1.822L327.579,292.551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M344.931,265.371c-2.546,2.797-1.061,25.705-1.887,27.274c-0.826,1.569-19.912-1.601-19.912-1.601 l-1.256,5.671c0,0,22.427,6.592,26.545,6.665c4.118,0.073,6.625-24.194,6.625-24.194s-0.567-3.379-3.581-7.684 C348.451,267.196,344.931,265.371,344.931,265.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M344.931,265.371c-2.546,2.797-1.061,25.705-1.887,27.274 c-0.826,1.569-19.912-1.601-19.912-1.601l-1.256,5.671c0,0,22.427,6.592,26.545,6.665c4.118,0.073,6.625-24.194,6.625-24.194 s-0.567-3.379-3.581-7.684C348.451,267.196,344.931,265.371,344.931,265.371z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M340.676,345.255h70.068v-4.459c0-3.752-3.042-6.794-6.794-6.794h-56.48 c-3.752,0-6.794,3.042-6.794,6.794V345.255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M340.676,345.255h70.068v-4.459 c0-3.752-3.042-6.794-6.794-6.794h-56.48c-3.752,0-6.794,3.042-6.794,6.794V345.255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M387.757,306.141H349.18c-1.984,0-3.452,2.151-3.005,4.403l6.897,34.713h1.593l-5.876-30.422 c-0.434-2.246,1.033-4.381,3.009-4.381h35.172L387.757,306.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M371.21,346.47v29.33c0,0.945,0.769,1.705,1.705,1.705h7.191c0.945,0,1.705-0.76,1.705-1.705 v-29.33H371.21z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238"
    },
    cx: 414.02,
    cy: 414.194,
    r: 3.116
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M412.462,414.194c0-0.861,0.697-1.558,1.558-1.558s1.558,0.698,1.558,1.558 s-0.698,1.558-1.558,1.558S412.462,415.054,412.462,414.194z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M335.891,414.194c0-1.721,1.395-3.116,3.116-3.116c1.721,0,3.116,1.395,3.116,3.116 s-1.395,3.116-3.116,3.116C337.286,417.31,335.891,415.915,335.891,414.194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M337.449,414.194c0-0.861,0.698-1.558,1.558-1.558c0.861,0,1.558,0.698,1.558,1.558 s-0.697,1.558-1.558,1.558C338.146,415.752,337.449,415.054,337.449,414.194z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M373.935,400.521v-33.524h5.156v33.524c20.076,0.515,32.276,7.533,34.718,9.072 c0.285,0.18,0.455,0.494,0.455,0.83v2.785c0,0.544-0.441,0.986-0.985,0.986l0,0c-0.354,0-0.681-0.19-0.856-0.497l-1.191-2.089 c0,0-13.809-4.924-32.14-5.322v5.51c0,0.704-0.571,1.275-1.275,1.275h-2.606c-0.704,0-1.275-0.571-1.275-1.275v-5.51 c-18.33,0.398-32.14,5.322-32.14,5.322l-1.191,2.089c-0.175,0.308-0.502,0.497-0.856,0.497l0,0c-0.544,0-0.986-0.441-0.986-0.986 v-2.785c0-0.337,0.17-0.651,0.455-0.83C341.659,408.054,353.858,401.035,373.935,400.521z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.822,
    y: 411.078,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 753.0264 828.3874)",
    style: {
      fill: "#263238"
    },
    width: 3.383,
    height: 6.232
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.21,
    y: 346.47,
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 10.601,
    height: 12.186
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M338.761,343.449v3.503c0,0.991,0.692,1.789,1.543,1.789h70.815c0.851,0,1.535-0.797,1.535-1.789 v-3.503c0-0.982-0.684-1.788-1.535-1.788h-70.815C339.453,341.661,338.761,342.467,338.761,343.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M371.34,345.257h41.315c0,0,13.127-21.559,13.127-57.182v-13.081c0-5.374-4.416-9.735-9.865-9.735 h-17.519c-5.338,0-9.706,4.188-9.857,9.46C388.031,293.072,385.294,332.819,371.34,345.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M380.428,345.257h30.359c1.174,0,2.25-0.639,2.791-1.668 c2.988-5.692,12.204-25.666,12.204-55.514v-13.081c0-5.376-4.413-9.735-9.857-9.735h-15.14c-5.338,0-9.706,4.188-9.858,9.46 c-0.455,16.397-2.688,49.871-13.11,65.689C376.441,342.496,377.905,345.257,380.428,345.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M338.761,343.449v3.503c0,0.988,0.687,1.789,1.536,1.789h31.736 c1.147,0,2.076-1.083,2.076-2.418v-2.243c0-1.336-0.93-2.418-2.076-2.418h-31.728 C339.453,341.661,338.761,342.467,338.761,343.449z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E__53_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4897B"
    },
    d: "M150.11,268.63l-3.03,0.72l-0.7-2.44c0,0-0.9,0.6-2.14,0c-0.34-0.16-0.81-0.45-1.33-0.79 c-1.35-0.89-2.95-2.11-2.95-2.11l2.34-4.77c0,0,1.02,0.41,2.27,0.96c1.76,0.79,3.97,1.84,4.36,2.4 c0.66,0.95,0.33,2.72,0.33,2.72L150.11,268.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M142.91,266.12c-1.35-0.89-2.95-2.11-2.95-2.11l2.34-4.77 c0,0,1.02,0.41,2.27,0.96C144.68,261.6,144.56,264.05,142.91,266.12z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E4897B"
    },
    points: "191.963,378.787 186.947,380.749 183.337,373.949 180.058,367.763 185.62,364.43  188.978,372.023  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "188.978,372.023 183.337,373.949 180.058,367.763  185.62,364.43  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M187.938,368.314l-6.827,3.663c0,0-25.791-45.35-29.758-44.973 c-3.967,0.376-41.592,24.358-53.066,15.502c-11.473-8.848-0.309-35.517-0.309-35.517s23.736-6.784,26.31-1.567 c0.501,1.008,1.172,3.03,1.7,4.766c0.506,1.634,0.888,3.013,0.888,3.013s0.008-0.001,0.015-0.01 c0.723-0.292,24.167-9.905,34.633-4.753C172.156,313.679,187.938,368.314,187.938,368.314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M187.938,368.314l-6.827,3.663 c0,0-25.791-45.35-29.758-44.973c-3.967,0.376-41.592,24.358-53.066,15.502c-11.473-8.848-0.309-35.517-0.309-35.517 s23.736-6.784,26.31-1.567c0.501,1.008,1.172,3.03,1.7,4.766c0.506,1.634,0.888,3.013,0.888,3.013s0.008-0.001,0.015-0.01 c0.723-0.292,24.167-9.905,34.633-4.753C172.156,313.679,187.938,368.314,187.938,368.314z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E4897B"
    },
    points: "150.857,405.295 145.506,404.682 145.481,397.129 145.469,390.201 151.94,389.896  151.37,398.049  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "151.351,398.214 145.464,397.276 145.461,390.275  151.936,389.933  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "177.773,369.725 187.763,364.722 188.801,368.954 181.239,372.856  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M116.012,342.578c0,0,1.645-0.187,26.877-4.861c0,0,0.569,32.271,1.766,56.323l7.772,0.251 c0,0,11.148-53.388,9.839-61.447c-1.309-8.059-10.904-9.151-10.904-9.151S134.708,336.632,116.012,342.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M116.012,342.578c0,0,1.645-0.187,26.877-4.861 c0,0,0.569,32.271,1.766,56.323l7.772,0.251c0,0,11.148-53.388,9.839-61.447c-1.309-8.059-10.904-9.151-10.904-9.151 S134.708,336.632,116.012,342.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M116.012,342.578c0,0,1.645-0.187,26.877-4.861 c0,0,0.569,32.271,1.766,56.323l7.772,0.251c0,0,11.148-53.388,9.839-61.447c-1.309-8.059-10.904-9.151-10.904-9.151 S134.708,336.632,116.012,342.578z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "143.229,391.889 153.829,391.642 152.378,396.01 143.78,396.088  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M201.938,387.682c-0.839-0.254-1.717-0.353-2.591-0.292l0,0c0,0-3.239-1.352-7.15-7.795 l-3.342,0.44c-1.154,0.172-2.078,1.047-2.313,2.19c-0.034,0.156-0.045,0.316-0.031,0.475c0.145,0.802,0.341,1.594,0.587,2.371 c0.644,2.457,3.032,7.588,3.032,7.588l0.546-0.222l-1.714-4.841c-0.575-1.646,1.429-0.255,2.489,1.339 c1.06,1.594,2.562,3.138,6.134,1.788C201.744,389.127,203.391,388.27,201.938,387.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4897B"
    },
    d: "M191.345,377.884c0,0,5.369,8.152,8.001,9.507c0,0-2.955,2.362-6.894-1.45 c-5.094-4.929-5.942-3.24-5.942-3.24s-0.076-1.916,0.135-2.888C187.052,377.941,191.345,377.884,191.345,377.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M158.865,414.785c-0.754-0.446-1.584-0.75-2.448-0.898l0,0c0,0-2.826-2.081-5.098-9.268 l-3.351-0.365c-1.162-0.107-2.267,0.524-2.766,1.579c-0.07,0.143-0.119,0.297-0.143,0.454c-0.05,0.814-0.047,1.63,0.008,2.443 c0.043,2.539,1.146,8.091,1.146,8.091l0.583-0.086l-0.517-5.11c-0.168-1.735,1.449,0.091,2.1,1.891 c0.651,1.799,1.744,3.656,5.535,3.191C158.335,416.143,160.138,415.701,158.865,414.785z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4897B"
    },
    d: "M150.899,402.755c0,0,3.283,9.193,5.519,11.133c0,0-3.431,1.594-6.353-3.043 c-3.779-5.996-5.004-4.556-5.004-4.556s0.38-1.879,0.816-2.773C146.714,401.792,150.899,402.755,150.899,402.755z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M144.76,249.268c0,0-1.848-0.048-2.713,1.273"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE5753"
    },
    d: "M143.952,253.667c0,0,1.075,1.602,2.168,2.495c0,0-0.464,0.94-1.634,0.912L143.952,253.667z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M144.892,251.768c0.068,0.532-0.165,1-0.519,1.045c-0.354,0.045-0.697-0.349-0.765-0.881 c-0.068-0.532,0.164-1,0.519-1.045C144.481,250.842,144.824,251.236,144.892,251.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M143.982,250.931l1.099-0.601C145.081,250.33,144.629,251.377,143.982,250.931z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4897B"
    },
    d: "M131.078,264.514c0.068,0.054,0.144,0.108,0.22,0.145c1.021,0.653,2.188,1.271,3.491,1.502 c3.646,0.656,6.086,0.042,7.613-1.668c0.008,0,0.008,0,0.008,0c2.132-2.557,2.483-6.92,1.91-12.134 c-0.256-2.391-0.7-4.461-1.44-6.052c-0.009-0.016-0.012-0.076-0.021-0.092c-0.036-0.064-0.065-0.154-0.101-0.217 c-1.098-2.22-2.809-3.609-5.458-4.101c-0.916-0.168-1.949-0.236-3.108-0.196C123.99,242.092,122.979,259.071,131.078,264.514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M131.298,264.659c1.021,0.653,2.181,1.128,3.484,1.359 c3.646,0.656,6.08-0.076,7.606-1.811c-1.751,0.478-4.126,0.741-6.495-0.214C134.401,263.395,132.794,263.817,131.298,264.659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M142.88,246.239c0,0,0.911,7.124-5.715,10.525c0,0-2.547,7.57-6.825,7.884 c-5.833,0.428-11.386-7.631-9.776-16.193C122.651,237.352,139.235,235.648,142.88,246.239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4897B"
    },
    d: "M140.497,254.543c-0.057-1.115-1.045-2.945-2.766-2.606c-1.782,0.351-2.56,4.823,1.898,5.596 C140.268,257.645,140.615,256.87,140.497,254.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M130.057,239.247c0,0,6.737-2.058,10.642,0.501c4.56,2.988,6.392,6.22,1.429,11.619 c0,0-11.635-3.154-15.404-2.182c-3.769,0.972-6.438,2.215-6.438,2.215C119.115,243.874,126.172,237.887,130.057,239.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4897B"
    },
    d: "M136.465,265.466c0,0-5.009,2.448-3.547,7.816l-12.754-5.31c0,0,6.966-0.438,6.614-5.336 C126.777,262.636,134.065,259.836,136.465,265.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M131.798,240.627c0,0-3.803-10.959-12.438-9.068c-8.635,1.891-7.967,11.157-1.793,14.023 C123.741,248.447,132.392,247.358,131.798,240.627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M119.949,245.403c0,0-7.617-0.045-6.677,6.487c0,0,0.656-2.116,2.371-2.985 c0,0-2.306,1.765-0.01,4.822c0,0-0.924-1.991,2.226-3.382s11.772-1.26,10.166-5.521 C126.419,240.564,119.949,245.403,119.949,245.403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M130.453,240.611c0,0-1.836-13.341-12.6-10.648"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M126.171,260.25c0,0-7.847-3.966-6.456-10.253"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M119.168,245.45c0,0-6.879-0.107-7.474,4.578"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M121.039,267.611l3.114-2.24c0,0,10.235,1.386,10.34,7.911 C134.599,279.807,121.039,267.611,121.039,267.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M119.168,267.611c0,0,7.676-1.476,18.359,5.671c0,0,3.575,15.644-11.538,36.906l-28.66-1.797 C97.328,308.391,105.088,277.066,119.168,267.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M126.876,313.2l-9.755,4.897c0,0,3.231-5.399,8.866-7.91 C126.494,311.822,126.876,313.2,126.876,313.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M136.66,287.7c-0.48,2.01-1.14,4.2-2.02,6.53 c-1.79,4.77-4.52,10.15-8.65,15.96l-28.66-1.8c0,0,7.76-31.32,21.84-40.78c0,0,7.67-1.47,18.36,5.67 C137.53,273.28,138.79,278.79,136.66,287.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M136.66,287.7c-0.48,2.01-1.14,4.2-2.02,6.53 c-0.31-3.41,0.06-7.08,0.06-7.08C135.44,287.23,136.09,287.42,136.66,287.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M137.526,273.282c0,0,8.429,12.118,10.605,13.28c2.176,1.162-2.012-18.951-2.012-18.951 l4.067-0.884c0,0,7.21,24.184,2.374,28.336c-4.836,4.152-17.864-7.91-17.864-7.91s-0.457-4.747,0-8.308 C135.154,275.286,137.526,273.282,137.526,273.282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M137.526,273.282c0,0,8.429,12.118,10.605,13.28 c2.176,1.162-2.012-18.951-2.012-18.951l4.067-0.884c0,0,7.21,24.184,2.374,28.336c-4.836,4.152-17.864-7.91-17.864-7.91 s-0.457-4.747,0-8.308C135.154,275.286,137.526,273.282,137.526,273.282z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M144.665,345.255H74.598v-4.459c0-3.752,3.042-6.794,6.794-6.794h56.48 c3.752,0,6.794,3.042,6.794,6.794V345.255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M144.665,345.255H74.598v-4.459 c0-3.752,3.042-6.794,6.794-6.794h56.48c3.752,0,6.794,3.042,6.794,6.794V345.255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M97.584,306.141h38.577c1.984,0,3.452,2.151,3.005,4.403l-6.897,34.713h-1.593l5.876-30.422 c0.434-2.246-1.033-4.381-3.009-4.381H98.371L97.584,306.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M114.131,346.47v29.33c0,0.945-0.769,1.705-1.705,1.705h-7.191c-0.945,0-1.705-0.76-1.705-1.705 v-29.33H114.131z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M74.438,414.194c0-1.721-1.395-3.116-3.116-3.116c-1.721,0-3.116,1.395-3.116,3.116 s1.395,3.116,3.116,3.116C73.043,417.31,74.438,415.915,74.438,414.194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M72.88,414.194c0-0.861-0.698-1.558-1.558-1.558c-0.86,0-1.558,0.698-1.558,1.558 s0.698,1.558,1.558,1.558C72.182,415.752,72.88,415.054,72.88,414.194z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M149.451,414.194c0-1.721-1.395-3.116-3.116-3.116c-1.721,0-3.116,1.395-3.116,3.116 s1.395,3.116,3.116,3.116C148.055,417.31,149.451,415.915,149.451,414.194z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    cx: 146.335,
    cy: 414.194,
    r: 1.558
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M111.406,400.521v-33.524h-5.156v33.524c-20.076,0.515-32.276,7.533-34.717,9.072 c-0.285,0.18-0.455,0.494-0.455,0.83v2.785c0,0.544,0.441,0.986,0.986,0.986l0,0c0.354,0,0.681-0.19,0.856-0.497l1.191-2.089 c0,0,13.81-4.924,32.14-5.322v5.51c0,0.704,0.571,1.275,1.275,1.275h2.606c0.704,0,1.275-0.571,1.275-1.275v-5.51 c18.33,0.398,32.14,5.322,32.14,5.322l1.191,2.089c0.175,0.308,0.502,0.497,0.856,0.497l0,0c0.544,0,0.986-0.441,0.986-0.986 v-2.785c0-0.337-0.17-0.651-0.455-0.83C143.682,408.054,131.483,401.035,111.406,400.521z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.137,
    y: 411.078,
    style: {
      fill: "#263238"
    },
    width: 3.383,
    height: 6.232
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.53,
    y: 346.47,
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 10.601,
    height: 12.186
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M146.581,343.449v3.503c0,0.991-0.692,1.789-1.543,1.789H74.222c-0.851,0-1.535-0.797-1.535-1.789 v-3.503c0-0.982,0.684-1.788,1.535-1.788h70.815C145.889,341.661,146.581,342.467,146.581,343.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M114.001,345.257H72.687c0,0-13.127-21.559-13.127-57.182v-13.081 c0-5.374,4.416-9.735,9.865-9.735h17.519c5.338,0,9.706,4.188,9.858,9.46C97.31,293.072,100.047,332.819,114.001,345.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M104.913,345.257H74.554c-1.174,0-2.25-0.639-2.791-1.668 c-2.988-5.692-12.204-25.666-12.204-55.514v-13.081c0-5.376,4.413-9.735,9.857-9.735h15.14c5.338,0,9.706,4.188,9.857,9.46 c0.455,16.397,2.688,49.871,13.11,65.689C108.9,342.496,107.436,345.257,104.913,345.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M146.581,343.449v3.503c0,0.988-0.688,1.789-1.536,1.789h-31.736 c-1.147,0-2.076-1.083-2.076-2.418v-2.243c0-1.336,0.929-2.418,2.076-2.418h31.728 C145.889,341.661,146.581,342.467,146.581,343.449z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit3);
export default __webpack_public_path__ + "static/media/edit3.e0089f3d1aa8d99ae8eca9d4f1b3070c.svg";
export { ForwardRef as ReactComponent };